<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    if (localStorage.getItem("store")) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(localStorage.getItem("store"))))
      localStorage.removeItem("store")
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      localStorage.setItem("store", JSON.stringify(this.$store.state))
    })
  }
}
</script>

<style>
* {
  padding: 0px 0px;
  margin: 0px 0px;
}
.el-header {
  padding: 0;
}
.el-main {
  padding: 0;
}
.el-footer {
  padding: 0;
}
html,
body {
  height: 100%;
}
#app {
  height: 100%;
  background-image: url('~@/assets/images/pingr.png');
  background-size: 100% 100%;
  background-repeat: repeat;
}
@media screen and (max-width: 768px) {
}
input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px white inset !important;
}

/* ⽅法⼀ */
@media screen and (min-width: 1024px) {
  html {
    font-size: 10px;
  }
}
@media screen and (min-width: 1100px) {
  html {
    font-size: 12px;
  }
}
/* @media (min-width: 1280px) { html{font-size: 22px;} } */
@media screen and (min-width: 1280px) {
  html {
    font-size: 12px;
  }
}
@media screen and (min-width: 1366px) {
  html {
    font-size: 13px;
  }
}
@media screen and (min-width: 1440px) {
  html {
    font-size: 14px;
  }
}
@media screen and (min-width: 1680px) {
  html {
    font-size: 16px;
  }
}
@media screen and (min-width: 1920px) {
  html {
    font-size: 20px;
  }
}
@media screen and (min-width: 2048px) {
  html {
    font-size: 20px;
  }
}
@media screen and (min-width: 2560px) {
  html {
    font-size: 26px;
  }
}
@media screen and (min-width: 4096px) {
  html {
    font-size: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue